import { render } from "./HomePage.vue?vue&type=template&id=9479961a&scoped=true&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=9479961a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9479961a"]])

export default __exports__